import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-gate-keeper-control-find-element-by-qr-camera-picker-dialog',
  templateUrl: './gkc-camera-picker-dialog.component.html',
  styleUrls: ['./gkc-camera-picker-dialog.component.scss']
})
export class GKCFindElementByQrCameraPickerDialogComponent {

  availableCameras: MediaDeviceInfo[];

  selectedCamera: MediaDeviceInfo;

  constructor(public dialogRef: MatDialogRef<GKCFindElementByQrCameraPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    this.availableCameras = data.availableCameras;
    this.selectedCamera = this.selectedCamera;
  }

  close() {
    this.dialogRef.close(null);
  }

  confirm() {
    this.dialogRef.close(this.selectedCamera);
  }

  selectCamera(camera: MediaDeviceInfo) {
    this.selectedCamera = camera;
  }


}
